import React from 'react';
import './CareerHeroSection.css';

function CareerHeroSection() {
  return (
    <section className="career-hero">
      {/* <div className="career-hero-content">
        <h1>Join Our Team at NorthHawks</h1>
        <p>Shape the future of technology with us. Explore exciting opportunities and grow your career.</p>
      </div> */}
    </section>
  );
}

export default CareerHeroSection;